








import axios from 'axios';


/**
 * Options for creating a todo client.
 *
 * @public
 */









/**
 * An implementation of the AgentApi that talks to the agent plugin backend.
 *
 * @public
 */

export class PSNClient  {
    discoveryApi;
    identityApi;

   header = {
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  };

  constructor(options) {
    this.discoveryApi = options.discoveryApi;
    this.identityApi = options.identityApi;
  }

  async getData() {
    const baseUrl = await this.discoveryApi.getBaseUrl('reminder');
    try {
      const res = await axios.get(`${baseUrl}/data`);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async addData(whitelistData) {
    const baseUrl = await this.discoveryApi.getBaseUrl('reminder');
    const email = await this.getUserEmail();
    try {
      const { data } = await axios.post(
        `${baseUrl}/data`,
        JSON.stringify({
          ...whitelistData,
          username: email,
        }),
        this.header,
      );
      return data;
    } catch (error) {
      throw error;
    }
  }

  async deleteData(id) {
    const baseUrl = await this.discoveryApi.getBaseUrl('reminder');
    const email = await this.getUserEmail();
    try {
      const res = await axios.delete(`${baseUrl}/data/${id}?email=${email}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async updateData(data) {
    const baseUrl = await this.discoveryApi.getBaseUrl('reminder');
    const email = await this.getUserEmail();
    try {
      const res = await axios.put(
        `${baseUrl}/data`,
        JSON.stringify({ ...data, username: email }),
        this.header,
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async createJira(data) {
    const baseUrl = await this.discoveryApi.getBaseUrl('reminder');
    try {
      const res = await axios.post(
        `${baseUrl}/jira`,
        JSON.stringify(data),
        this.header,
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async getConfigLog() {
    const baseUrl = await this.discoveryApi.getBaseUrl('reminder');
    try {
      const { data } = await axios.get(`${baseUrl}/log/config`);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async getConfig() {
    const baseUrl = await this.discoveryApi.getBaseUrl('reminder');
    try {
      const { data } = await axios.get(`${baseUrl}/config`);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async saveConfig(
    method,
    config,
  ) {
    const baseUrl = await this.discoveryApi.getBaseUrl('reminder');
    const email = await this.getUserEmail();
    try {
      const { data } = await axios({
        url: `${baseUrl}/config`,
        method: method,
        data: { ...config, username: email },
      });
      return data;
    } catch (error) {
      throw error;
    }
  }

  async getLog() {
    const baseUrl = await this.discoveryApi.getBaseUrl('reminder');
    try {
      const { data } = await axios.get(`${baseUrl}/log/data`);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async getUserEmail() {
    const { email } = await this.identityApi.getProfileInfo();
    return email ?? 'unknown';
  }
}
